<template>
	<!-- 文章 -->
	<div class="article" @scroll="scrollEvent">
		<!-- <div class="art" v-for="(item,index) in list" :key="index">
			<div class="ta-c art-date">
				<div  v-text="dateInit(item.update_time)"></div>
			</div>
			<div class="bg-f" v-for="(row,j) in item.content.news_item" :key="j" @click="toArtInfo(row.url,item.media_id)">
				<div v-if="j===0">
					<div class="art-tit">
						<img :src="row.thumb_url" alt="">
						<div class=""><div class="">{{row.title}}</div></div>
					</div>
					<div class="art-dis" v-if="item.content.news_item.length===1">
						<div class="clamp-2">{{row.title}}</div>
						<div class="init">
							<span>详情</span>
							<van-icon name="arrow" />
						</div>
					</div>
				</div>
				<div class="art-item" v-else>
					<div class="clamp-2">{{row.title}}</div>
					<div>
						<img :src="row.thumb_url" alt="">
					</div>
				</div>
			</div>
		</div> -->
		<div class="art" v-for="(item,index) in list" :key="index">
			<div class="ta-c art-date">
				<div>{{item.cTime}}</div>
			</div>
			<div class="bg-f" @click="toArtInfo(item.linkAddress,item.id)">
				<div>
					<div class="art-tit">
						<img :src="item.iconAddress" alt="">
						<div class=""><div class="">{{item.title}}</div></div>
					</div>
					<div class="art-dis">
						<div class="clamp-2">{{item.simpleInfo}}</div>
						<div class="init">
							<span>详情</span>
							<van-icon name="arrow" />
						</div>
					</div>
				</div>
				<!-- <div class="art-item" v-else>
					<div class="clamp-2">{{item.title}}</div>
					<div>
						<img :src="item.iconAddress" alt="">
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>
<script>
import { Toast } from 'vant';
export default {
	name: '',
	data() {
		return {
			list:[],
			content:'',
			url:'',
			page:0,
			rows:10,
			access_token:'',
			userId:'',
			baseURL:'',
		};
	},
	created() {
		this.userId = this.$route.query.userId;
		 // this.getToken();
		this.getList();
	},
	mounted() {
		document.querySelector('body').setAttribute('style', 'background-color:#F8F8F8');
		document.querySelector('title').innerText = '首单贡献值奖励';
	},
	methods: {
		//滚动条触发事件
		scrollEvent(e) {
		   // console.log(e.srcElement.scrollHeight - (e.srcElement.scrollTop + e.srcElement.clientHeight))
		   // if ( (e.srcElement.scrollHeight - (e.srcElement.scrollTop + e.srcElement.clientHeight))<=60  ) {
			  //  console.log('到底了')
		   //    this.page += this.rows;
		   //    this.getList(1);
		   // }
		},
		async getList(type=0){
			// 添加积分
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let params = {
				// "offset":this.page,
				// "count":this.rows
			}
			let res = await this.$axios.get(`common/v1/slnotice/selectytNotices`,params);
			console.log("res",res);
			if(res.data.success){
				this.list = res.data.data;
			}else{
				Toast(res.data.msg);
			}
			
			// for(let i=0;i<item.length;i++){
			// 	console.log('res',item[i].content.news_item);
			// 	if(item[i].content.news_item.length>1){
			// 		this.list = [item[i]];
			// 		break;
			// 	}
			// }
			// this.list = type===0?res.data.item:[...this.list,...res.data.item];
			this.$nextTick(()=>{
				Toast.clear();
			})
		},
		async toArtInfo(url,mediaId){
			// 添加积分
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let params = {
				userId:this.userId,
				msg:mediaId,
			}
			let res = await this.$axios.post(`common/v1/ContribDetail/sendContribDetailByRead`,params);
			console.log('res',res);
			if(res.data.success){
				Toast.clear();
				
				var a = document.createElement("a");
				a.setAttribute("href", url);
				// a.setAttribute("target", "_blank");//重新打开窗口
				a.click();
			}else{
				Toast.clear();
				Toast(res.data.msg);
			}
		},
		async getToken(type=0){
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let APPID="wx994320d0aac3cee8";
			let APPSECRET="b54c349b3da395f47236639ae7a8fbe6";
			this.baseURL = window.location.origin;
			this.$axios({
			  url: `${this.baseURL}/cgi-bin/token?grant_type=client_credential&appid=${APPID}&secret=${APPSECRET}`,
			  method: 'GET',
			  headers: {
			  	"Content-Type": "application/json",
			  }
			}).then((res) => {
				this.access_token = res.data.access_token;
				this.getWxList(type);
			}).catch((error)=>{
				console.log(error);
			});
		},
		async getWxList(type){
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let params = {
				"type":"news",
				"offset":this.page,
				"count":this.rows
			}
			this.$axios({
				url: `${this.baseURL}/cgi-bin/material/batchget_material?access_token=${this.access_token}`,
				method: 'post',
				data:params,
				headers: {
					"Content-Type": "application/json",
				}
			}).then((res) => {
				this.list = type===0?res.data.item:[...this.list,...res.data.item]
			}).catch((error)=>{
				console.log(error);
			});
		},
		dateInit(d){
			return this.$util.dateFormat(new Date(Number(d+'000')),"yyyy-MM-dd hh:mm:ss");
		}
	}
};
</script>
<style lang="less" scoped>
.article {
	overflow-y: auto;
	height: 100vh;
	.art{
		// padding: 0.625rem;
		margin: 0.625rem 0.625rem 0.9375rem;
		border-radius: 0.25rem;
		.art-tit{
			position: relative;
			// width: 100%;
			// height: 12.5rem;
			// background-image: url("http://mmbiz.qpic.cn/mmbiz_jpg/wj0diaX2z6WvKGf1Yic8DVmaeI0ia1XbKJl4wDbC9UNutb9VbwmSJ4jib91QBnic1wbZiaN4l4wpYkSERRm0E0XAicC1g/0?wx_fmt=jpeg");
			// background-repeat: no-repeat;
			// background-size: 100% 100%;
			img{
				width: 100%;
				height: 12.5rem;
			}
			div{
				position: absolute;
				bottom: 0px;
				left: 0;
				right: 0px;
				background-color: rgba(0,0,0,.2);
				color: #FFFFFF;
				padding: 0.625rem 0.625rem;
				
			}
		}
		.art-dis{
			&>div:nth-child(1){
				color: #BCBCBB;
				padding: 0.625rem;
				font-size: 1rem;
			}
			&>div:nth-child(2){
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0.625rem;
			}
		}
		.art-date{
			display: flex;
			align-items: center;
			justify-content: center;
			div{
				padding:  0.1875rem;
				margin-bottom: 0.45rem;
				border-radius: 0.1875rem;
				color: #FFFFFF;
				background-color: #DBDBDB;
			}
		}
		.art-item{
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0.625rem;
			img{
				width: 5rem;
				height: 5rem;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/page/integral/article.vue